module.exports = __webpack_public_path__ + "static/warning-page-level-example-a5eb47dd5702cd5cf7e59d32c8bcdb61.svg";